import moment from 'moment';
import { ModelBase } from '../../abstract/model-base.model';

export class Downpayment extends ModelBase {

    static override CLASS_NAME: string = 'Downpayment';

    private _issueDate!: moment.Moment;
    private _mode!: string;
    private _value!: number;

    public get issueDate(): moment.Moment {
        return this._issueDate;
    }

    public set issueDate(value: moment.Moment) {
        this._setValue('_issueDate', value, 'date');
    }

    public get mode(): string {
        return this._mode;
    }

    public set mode(value: string) {
        this._setValue('_mode', value, 'string');
    }

    public get value(): number {
        return this._value;
    }

    public set value(value: number) {
        this._setValue('_value', value, 'float');
    }
}
